
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#ECD08C'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A18341'
        }
    }
})
